<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels v-model="status" flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <span class="body2-regular">{{ prices.totalPrice.name }}</span>
          <v-spacer></v-spacer>
          <div v-if="status != 0" class="my-auto d-flex body2-regular">
            <span class="title-price logistic--text my-auto mr-auto ml-3">
              {{ prices.totalPrice.value }}
            </span>
            <svg-icon class="ml-1" name="toman"></svg-icon>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0">
          <div class="prices-panel-content border-top mx-1 pr-1">
            <div v-for="(price, i) in prices.detail" :key="'price-' + i">
              <div class="price-item-section pt-4 row mx-0">
                <div>
                  <v-icon x-small class="ml-2 logistic--text force-color"
                    >mdi-circle</v-icon
                  >
                  <span class="medium-emp body2-light">{{ price.name }}:</span>
                </div>

                <v-spacer></v-spacer>

                <div>
                  <span class="subtitle1-regular">{{ price.value }}</span>
                  <span class="mr-2 mt-auto body2-light">تومان</span>
                </div>
              </div>
            </div>

            <hr class="border-dashed mt-3" />
            <div class="row mx-0 mt-2 logistic--text body2-regular">
              <span>جمع پرداختی:</span>
              <v-spacer></v-spacer>
              <span>
                <span class="subtitle1-medium">{{
                  prices.totalPrice.value
                }}</span>
                <span class="mr-2 mt-auto">تومان</span>
              </span>
            </div>

            <!-- <v-btn
              v-else
              large
              block
              outlined
              disabled
              :loading="wallet.loading"
              color="#1565C0"
              elevation="0"
              class="action-btn bold mt-3"
            >
              {{
                isPricePayed === true
                  ? "کرایه پرداخت شده"
                  : isPricePayed === false
                  ? "پرداخت نقدی در مقصد"
                  : "خطا در کیف پول"
              }}
            </v-btn> -->
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  name: "PricesPanel",
  props: {
    load: {
      type: Object,
      required: true,
    },
    wallet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: null,
    };
  },
  computed: {
    prices() {
      const insurance = +this.load.insurance / 10;
      const price = +this.load.price / 10 - insurance;
      const totalPrice = +this.load.price / 10;

      return {
        detail: {
          price: {
            name: "کرایه کل",
            value: this.$utils.formatNumber(price),
          },
          insurance: {
            name: "بیمه",
            value: this.$utils.formatNumber(insurance),
          },
        },
        totalPrice: {
          name: "کرایه حمل",
          value: this.$utils.formatNumber(totalPrice),
        },
      };
    },
    isPricePayed() {
      if (!this.load) return;

      const isDataEmpty = Object.keys(this.load).length === 0;
      if (isDataEmpty) return;

      const data = this.load;
      if (data.price_payed || data.payed_from_wallet) return true;

      if (!this.wallet.loaded) return;

      const balance = Number(this.wallet.balance);
      const totalPrice = Number(data.price) / 10 + Number(data.insurance) / 10;
      return balance >= totalPrice;
    },
  },
};
</script>

<style scoped>
.title-text {
  font-size: 12px;
}
.title-price {
  text-align: left;
}
.border-dashed {
  border-style: dashed;
  opacity: 0.4;
}
</style>

<style>
.theme--light.v-expansion-panels
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  filter: grayscale(100%);
}
</style>